import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { TimeoutError } from '../errors/TimeoutError.js'; // `Promise.race()` workaround (#91)

export var timeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, abortController, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var timeoutID = setTimeout(function () {
                if (abortController) {
                  abortController.abort();
                }

                reject(new TimeoutError(request));
              }, options.timeout);
              /* eslint-disable promise/prefer-await-to-then */

              /* eslint-disable promise/prefer-await-to-then */
              void options.fetch(request).then(resolve).catch(reject).then(function () {
                clearTimeout(timeoutID);
              });
              /* eslint-enable promise/prefer-await-to-then */
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function timeout(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var delay = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ms) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              setTimeout(resolve, ms);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function delay(_x4) {
    return _ref2.apply(this, arguments);
  };
}();